import clsx from 'clsx';
import React, { FunctionComponent, MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import useStyles from './TransLink.style';

export const TransLink: FunctionComponent<{
  path: string;
  className?: string;
  onClick?: MouseEventHandler<any>;
  currentScreenCode?: string;
  scrollToSection?: boolean;
  ariaLabel?: string;
  autoTestId?: string;
}> = ({ path, className, onClick, children, currentScreenCode, scrollToSection, ariaLabel, autoTestId }) => {
  const c = useStyles({});
  const [url] = useTranslation('url');

  let to = path.split('/').reduce((result, c) => `${result}${url(c)}/`, '');
  to = to.substring(0, to.length - 1);

  return (
    <Link
      to={{pathname: to, state: {currentScreenCode, scrollToSection}}}
      className={clsx(c.root, className)}
      onClick={onClick}
      aria-label={ariaLabel}
      data-autotestid={autoTestId}
    >
      {children}
    </Link>
  );
};
